export const SliderItems = [
    {
        id: 1,
        img: "https://i.ibb.co/DG69bQ4/2.png",
        title: "SUMMER SALE",
        desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
        bg: "f5fafd",
      },
      {
        id: 2,
        img: "https://i.ibb.co/DG69bQ4/2.png",
        title: "AUTUMN COLLECTION",
        desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
        bg: "fcf1ed",
      },
      {
        id: 3,
        img: "https://i.ibb.co/cXFnLLV/3.png",
        title: "LOUNGEWEAR LOVE",
        desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
        bg: "fbf0f4",
      },
]
export const categories = [
    {
      id: 1,
      img: "https://images.unsplash.com/photo-1521335629791-ce4aec67ddaf?auto=format&fit=crop&w=1200&q=80",
      title: "SHIRT STYLE!",
      cat:"women"
    },
    {
      id: 2,
      img: "https://images.unsplash.com/photo-1523381214305-79448d4ae3ea?auto=format&fit=crop&w=1200&q=80",
      title: "LOUNGEWEAR LOVE",
      cat:"jeans"
    },
    {
      id: 3,
      img: "https://images.unsplash.com/photo-1526170375885-4d8ecf77b99f?auto=format&fit=crop&w=1200&q=80",
      title: "LIGHT JACKETS",
      cat:"jacket"

    },
  ];

  
  export const popularProducts = [
    {
      id:1,

      img:"https://source.unsplash.com/featured/?t-shirt",
    },
    {
      id:2,
      img:"https://source.unsplash.com/featured/?shirt",
    },
    {
      id:3,
      img:"https://source.unsplash.com/featured/?fashion",
    },
    {
      id:4,
      img:"https://source.unsplash.com/featured/?jacket",
    },
    {
      id:5,
      img:"https://source.unsplash.com/featured/?bag",
    },
    {
      id:6,
      img:"https://source.unsplash.com/featured/?cap",
    },
    {
      id:7,
      img:"https://source.unsplash.com/featured/?coat",
    },
    {
      id:8,
      img:"https://source.unsplash.com/featured/?hoodie",
    },
  ]
